// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 8H14V6H10C8.34315 6 7 7.34315 7 9H10V15H7C7 16.6569 8.34315 18 10 18H14V16H22V22H14V20H10C7.23858 20 5 17.7614 5 15H2V9H5C5 6.23858 7.23858 4 10 4H14V2H22V8Z"}}]};

const MindMapFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mind-map-filled',
    ref,
    icon: element,
  },
));

MindMapFilledIcon.displayName = 'MindMapFilledIcon';

export default MindMapFilledIcon;
